import BackgroundImage from 'gatsby-background-image';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Box, Flex } from 'rebass/styled-components';

import { layout } from '../../../../constants/constants';
import { Media } from '../../../contexts/media/MediaContext';
import { IconPack, MediumImpactContainerHeroContent } from '../../../models/app-data-model';
import Breadcrumbs from '../../bread-crumbs/breadcrumbs';
import ButtonWrapper from '../../button-wrapper/button-wrapper';
import './medium-impact-container.scss';
import { corewellHeroOverrideClasses } from '../../../../constants/constants';

export type HeroContentProps = {
  heroContent: MediumImpactContainerHeroContent;
  corewellStyleOverrides?: boolean;
  iconPack: IconPack[];
};

const HeroMediumImpactContainer: React.FC<HeroContentProps> = ({ heroContent, iconPack, corewellStyleOverrides }: HeroContentProps) => {
  const {
    header,
    image_desktop: imageDesktop,
    image_mobile: imageMobile,
    background_color: backgroundColor,
    subtext,
    primary_button: primaryButton,
    secondary_button: secondaryButton,
    breadcrumbs
  } = heroContent;

  const corewellHeadingClassOverrides = corewellStyleOverrides ? `${corewellHeroOverrideClasses?.mediumImpactHeroHeadingOverride}` : '';
  const headingClass = `header ${corewellHeadingClassOverrides}`;

  const corewellBodyClassOverrides = corewellStyleOverrides ? `${corewellHeroOverrideClasses?.mediumImpactHeroBodyOverride}` : '';
  const bodyClass = `subtext ${corewellBodyClassOverrides}`;

  return (
    <Flex className="medium-impact-container" flexWrap="wrap" style={{ backgroundColor: backgroundColor?.[0]?.color?.color }}>
      <Box width={[1, 1, 1, 1, 1 / 2]}>
        <Flex className="card-container" width={layout.pageWidth}>
          <div className="card">
            {breadcrumbs && <Breadcrumbs breadcrumbsContent={breadcrumbs}></Breadcrumbs>}
            {header && <h1 className={headingClass}>{header}</h1>}
            {subtext && <p className={bodyClass}>{subtext}</p>}
            <div className="actions">
              {primaryButton?.text && primaryButton?.reference && (
                <ButtonWrapper
                  buttonId={primaryButton?.button_id}
                  type="primary"
                  label={primaryButton.text}
                  reference={primaryButton.reference}
                  iconPack={iconPack}
                />
              )}
              {secondaryButton?.text && secondaryButton?.reference && (
                <ButtonWrapper type="secondary" label={secondaryButton.text} reference={secondaryButton.reference} />
              )}
            </div>
          </div>
        </Flex>
      </Box>
      <Box width={[1, 1, 1, 1, 1 / 2]} className="image-container">
        <Media lessThan="desktop">
          <GatsbyImage
            className="image"
            image={imageMobile?.file?.localAsset?.childImageSharp?.gatsbyImageData}
            alt={imageMobile?.alt_text}
          />
        </Media>
        <Media greaterThanOrEqual="desktop" className="desktop-image-container">
          <BackgroundImage className="image" fluid={imageDesktop?.file?.localAsset?.childImageSharp?.fluid}>
            <span role="img" aria-label={imageDesktop?.alt_text} />
          </BackgroundImage>
        </Media>
      </Box>
    </Flex>
  );
};

export default HeroMediumImpactContainer;
